/* eslint-disable no-console, no-eval, react/no-danger */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TileGrid from 'components/TileGrid';
import _ from 'lodash';
import Loader from 'components/Loader';
import { PANEL_TYPE_PROMOS, isStaticRender } from 'helpers/ContentHelper';
import { PageNames } from '@foxcorp/delta-web-analytics';
import { setHelmetTags } from 'helpers/HelmetHelper';
import { fetchPromoList } from './PromoListActions';
import { getPromoListApiUrl, promoListProcessor } from './PromoListHelpers';
import tileStyle from './tiles.css';

class PromoList extends Component {
  componentDidMount() {
    const { accessToken, deviceId, fetchPromoList, pageViewEvent, seriesType, url } = this.props;
    if (url && fetchPromoList && !isStaticRender()) {
      fetchPromoList(url, accessToken, deviceId);
    }
    pageViewEvent({ pageName: PageNames.PROMO_LIST, seriesType });
  }

  componentDidUpdate(prevProps) {
    const { url: prevUrl, errors: prevErrors, fetchPromoList } = prevProps;
    const { url, pageViewEvent, setErrors, errors, accessToken, deviceId } = this.props;

    if (prevUrl !== url) {
      pageViewEvent({ pageName: PageNames.PROMO_LIST });
      fetchPromoList(url, accessToken, deviceId);
    }
    if (prevErrors !== errors) {
      setErrors(errors);
    }
  }

  renderPanels() {
    const { panels, setLoading } = this.props;
    if (!panels || !panels.member || panels.length === 0) return <Loader setLoading={setLoading} />;
    return panels.member.map(panel => {
      const { panelType } = panel;
      const { headline } = panel;
      switch (panelType) {
        case PANEL_TYPE_PROMOS:
          if (!headline) return null;
          return this.renderPromoList(panel);
        default:
          return null;
      }
    });
  }

  renderPromoList(item) {
    const { theme } = this.props;
    const { headline, id } = item;
    const items = _.get(item, 'items.member');
    return (
      <div key={`promo-list-detail-${id}`} className={theme.container}>
        <h3 className={theme.headline}>{headline}</h3>
        <TileGrid
          items={items}
          processor={promoListProcessor}
          gridType="grid-2-1"
          tileTheme={tileStyle}
        />
      </div>
    );
  }

  render() {
    const { seo, containerId } = this.props;
    return (
      <div id={containerId}>
        {setHelmetTags(seo)}
        {this.renderPanels()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    panels: state.promoList.panels,
    errors: state.promoList.errors,
    seo: state.promoList.seo,
  };
}

PromoList.fetchData = ({ store, params, accessToken }) => {
  const id = params.articleId;
  const url = getPromoListApiUrl(id);
  return store.dispatch(fetchPromoList(url, accessToken));
};

PromoList.defaultProps = {
  accessToken: null,
  containerId: null,
  deviceId: null,
  errors: null,
  panels: null,
  seo: {},
  seriesType: '',
  setErrors: () => {},
  setLoading: null,
  theme: {},
  url: null,
};

PromoList.propTypes = {
  accessToken: PropTypes.string,
  containerId: PropTypes.string,
  deviceId: PropTypes.string,
  errors: PropTypes.number,
  fetchPromoList: PropTypes.func.isRequired,
  pageViewEvent: PropTypes.func.isRequired,
  panels: PropTypes.shape({
    member: PropTypes.array,
  }),
  seo: PropTypes.shape({}),
  seriesType: PropTypes.string,
  setErrors: PropTypes.func,
  setLoading: PropTypes.func,
  theme: PropTypes.shape({
    container: PropTypes.shape({}),
    title: PropTypes.string,
    body: PropTypes.string,
  }),
  url: PropTypes.string,
};

export default connect(mapStateToProps, { fetchPromoList })(PromoList);
